<template>
  <div />
</template>
<script>

import { CB, CINEPOLIS, isElectronMode, region } from 'src/config'

export default {
  name: 'ElectronScanner',
  created () {
    if (!isElectronMode) return
    // Add barcode scan listener and pass the callback function
    this.$barcodeScanner.init(this.onBarcodeScanned)
  },
  mounted () {
    this.reconnectScanner()
  },
  unmounted () {
    if (!isElectronMode) return
    // Remove listener when component is destroyed
    this.$barcodeScanner.destroy()
  },
  methods: {
    // Create callback function to receive barcode when the scanner is already done
    onBarcodeScanned (data) {
      // WARNING!! If changes are made here, also update the PI code as it also has this same logic.

      if (document.activeElement.tagName === 'INPUT') return

      data = _.trim(data)
      if (data[0] === '!' && data.slice(-1) === '#') {
        data = data.slice(1, -1)
      }
      if (data.endsWith('Enter')) {
        data = data.slice(0, data.length - 5)
      }

      if (region === CINEPOLIS && data.startsWith('%') && data.endsWith('?')) {
        data = `${data.split('?')[0]}?`
      }

      const skipEanBarcodes = region === CB

      const isNumberic = /^\d+$/.test(data)
      const isUpcA = data.length === 12 && isNumberic
      const isUpcE = data.length === 8 && isNumberic
      const isEan = data.length === 13 && isNumberic && !skipEanBarcodes
      if (isUpcA) {
        this.$remoteCommands.handleUpcScanned(data)
      } else if (isUpcE) {
        this.$remoteCommands.handleUpcScanned(data)
      } else if (isEan) {
        this.$remoteCommands.handleUpcScanned(data)
      } else if (data.length < 3) {
        // Do nothing, junk data
      } else if (data.split('/g/').length > 1) { // URL Encoded QR Codes
        const cardNumber = data.split('/g/')[1]
        this.$remoteCommands.handleCardData(cardNumber)
      } else if (data.split('/u/').length > 1) { // URL Encoded QR Codes
        const cardNumber = data.split('/u/')[1]
        this.$remoteCommands.handleCardData(cardNumber)
      } else if (data.split('%FCC4741951').length > 1) { // Farmington Civic Center Card Encoding
        const cardNumber = data.split('%FCC4741951')[1].slice(0, 10)
        this.$remoteCommands.handleCardData(cardNumber)
      } else if (_.startsWith(data, 'B6001')) {
        const cardNumber = _.last(data.split('Enter'))
        // B6001 is a special case for paytronics - we need the full magnetic card data for it to work
        this.$remoteCommands.handleCardData(cardNumber)
      } else if (data.length < 30) {
        this.$remoteCommands.handleCardData(data)
      } else if (data.split('^').length > 1) {
        // Special encoding for very long card data, delimited by '^' where the ID is the first part
        this.$remoteCommands.handleCardData(data.split('^')[0])
      } else {
        this.$remoteCommands.handleCardData(data)
      }

      console.log(data)
    },
    reconnectScanner () {
      if (!this.$barcodeScanner.hasListener() && isElectronMode) {
        this.$barcodeScanner.init(this.onBarcodeScanned)
      }
    }
  }
}
</script>
